module.exports = __webpack_public_path__ + "static/img/dankuang.4e781d5c.png";